"use strict";

require("../../style/index.less");

require("../../popover/style");

require("../../button/style");


//////////////////
// WEBPACK FOOTER
// ../~/antd/lib/popconfirm/style/index.js
// module id = 1212
// module chunks = 1